import * as React from "react";

// Subscribe to the ESC key while a modal is mounted, calling `onClose`.
//
// `enabled` (default true) lets a parent suspend the binding without
// remounting — useful when a modal opens a confirm dialog on top of itself
// and only the topmost layer should react to ESC.
//
// The listener is added at the document level with `capture: true` so it
// fires before any focused-element handlers that might call
// stopPropagation on bubble.
export function useEscapeKey(onClose: () => void, enabled: boolean = true): void {
  React.useEffect(() => {
    if (!enabled || !onClose) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [onClose, enabled]);
}
